/**
 * DevToggle · pill button in Topbar that toggles the dev-only unlock-all flag.
 * Per user request 3 MAY 2026 — лёгкий способ открыть все спринты для тестирования
 * без необходимости проходить S01..S05 заранее.
 *
 * Reactivity: localStorage is not React state · we force `window.location.reload()`
 * after toggle so all `isSprintLocked()` consumers re-evaluate. Reload is acceptable
 * for a dev-only switch; keeps `isSprintLocked` a pure function.
 */
import { useEffect, useState } from 'react';
import { DEV_UNLOCK_KEY, isDevUnlockAll } from '@/lib/sprint-progression';

export function DevToggle() {
  const [active, setActive] = useState<boolean>(false);

  useEffect(() => {
    setActive(isDevUnlockAll());
  }, []);

  const toggle = () => {
    const next = !active;
    try {
      if (next) window.localStorage.setItem(DEV_UNLOCK_KEY, '1');
      else window.localStorage.removeItem(DEV_UNLOCK_KEY);
    } catch {
      /* ignore quota errors */
    }
    window.location.reload();
  };

  return (
    <button
      type="button"
      onClick={toggle}
      className={`dev-toggle${active ? ' is-active' : ''}`}
      title={
        active
          ? 'DEV · все спринты разблокированы. Кликни, чтобы вернуть обычный режим.'
          : 'DEV · разблокировать все спринты для тестирования'
      }
      aria-pressed={active}
    >
      <span aria-hidden="true">{active ? '🔓' : '🔒'}</span>
      <span>DEV</span>
    </button>
  );
}
